import { render, staticRenderFns } from "./group-manage-detail.vue?vue&type=template&id=93bed62e&scoped=true&"
import script from "./group-manage-detail.vue?vue&type=script&lang=js&"
export * from "./group-manage-detail.vue?vue&type=script&lang=js&"
import style0 from "./group-manage-detail.vue?vue&type=style&index=0&id=93bed62e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bed62e",
  null
  
)

export default component.exports